import type React from 'react'
import type { UseFieldArrayProps, UseFieldArrayReturn } from 'react-hook-form'
import { useFieldArray, useFormContext } from 'react-hook-form'

interface ReactHookFieldArrayProps extends Omit<UseFieldArrayProps, 'control'> {
  render: (fieldArrayRenderProps: UseFieldArrayReturn) => NonNullable<React.ReactNode> | NonNullable<React.ReactNode>[]
}

export function ReactHookFieldArray({ render, ...fieldArrayProps }: ReactHookFieldArrayProps) {
  const { control } = useFormContext()
  const fieldArrayRenderProps = useFieldArray({ control, ...fieldArrayProps })
  return <>{render(fieldArrayRenderProps)}</>
}
